import { render, staticRenderFns } from "./ProductPromo.vue?vue&type=template&id=0473efb6"
import script from "./ProductPromo.vue?vue&type=script&lang=js"
export * from "./ProductPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports